import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AdjacentType, edgeTypeMatrix, getOnDemandProgrammeToEntityEdgeTypeId } from '@iotv/datamodel-core';
import { TypeIcons } from '../../../Iconography';
import { DefaultStepTypeFolderClickWrapper, ObjectTree } from '../../../v2/components/generic/ObjectTree';
import { ContextMenu } from '../ContextMenuV2/ContextMenu';
const debug = process.env.REACT_APP_DEBUG && false;
/** Customer to On Demand Programme */
export const customerOnDemandProgrammesTreeDef = {
    stepQuery: {
        objectTypeId: 'OnDemandProgramme',
        adjacencyType: AdjacentType.CHILD,
        edgeTypeId: edgeTypeMatrix.Customer.OnDemandProgramme.customer_has_on_demand_programme.edgeTypeId,
    },
    endIcon: TypeIcons.OnDemandProgramme,
    nextSteps: [],
    renderTypeFolder: false,
    thisStepTypeFolderClickWrapper: (props) => (_jsx(DefaultStepTypeFolderClickWrapper, { ...props,
        element: _jsx(_Fragment, { children: "On Demand Programmes" }),
        support: 'OnDemandProgramme' })),
    thisStepLabelWrapper: ({ vob, ascendentAccessor }) => (_jsx(ContextMenu, { ascendentAccessor,
        contextObject: vob,
        popUpElement: null,
        edgeTypeIdFilter: [edgeTypeMatrix.OnDemandProgramme.Entity.on_demand_programme_sequences_entity.edgeTypeId],
        hideAdd: true })),
    itemDerivedTreeFn: (vob, nodeEdgeMapper) => {
        return typeof vob.supportedType === 'string'
            ? [
                _jsx(ObjectTree, { contextObjects: [vob],
                    hideTopStep: true,
                    nodeEdgeMapper,
                    queryPaths: [
                        {
                            stepQuery: {
                                objectTypeId: vob.supportedType,
                                adjacencyType: AdjacentType.CHILD,
                                edgeTypeId: getOnDemandProgrammeToEntityEdgeTypeId(vob.supportedType),
                            },
                        },
                    ] }, vob.sk),
            ]
            : [];
    },
};
